var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DTC',{attrs:{"dtc":this.dtc,"v2":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }